const className = "api-oferty";

const apiName = "/pl/grupaenea/o-grupie/kariera-enea/";
let currentPath = window.location.pathname;
const subApiName = currentPath.replace(apiName, "") + "/kontent";
var page = new URLSearchParams(currentPath).get('page') || 1;

const fields = ['wojewodztwo', 'miejscowosc', 'spolka', 'kategoria', 'stanowisko', 'datapublikacji_od', 'datapublikacji_do', 'termin_skladania_od', 'termin_skladania_do', "sortuj"];
const targetClass = className + '-target';
const resetClass = className + '-reset';
const loader = document.querySelector('#spinner-loader-job-offers');

const fetchAndInsertHTML = async () => {
    loader.classList.remove('d-none');
    loader.classList.add('d-flex');
    document.querySelector(`.${targetClass}`).classList.add('d-none');
    document.querySelector(`.${targetClass}`).classList.remove('d-block');
    try {
        const endpoint = subApiName + '/' + fields
            .map(field => {
                const fieldValue = document.querySelector(`.${className}-${field}`).value;

                return encodeURIComponent(fieldValue || 'Wszystkie');
            })
            .join('/')+"?page="+page;
        const response = await fetch(endpoint);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const html = await response.text();

        document.querySelector(`.${targetClass}`).innerHTML = html;
        loader.classList.remove('d-flex');
        loader.classList.add('d-none');
        document.querySelector(`.${targetClass}`).classList.remove('d-none');
        document.querySelector(`.${targetClass}`).classList.add('d-block');
    } catch (error) {
        console.error('Error during fetch:', error);
    }
};

const resetFields = () => {
    page = 1;
    fields.forEach(field => {
        const fieldElement = document.querySelector(`.${className}-${field}`);
        if (fieldElement) {
            fieldElement.value = '';
        }
    });
    fetchAndInsertHTML();
};

const inputClicked = () => {
    page = 1;
    fetchAndInsertHTML();
}

fields.forEach(field => {

    const fieldElement = document.querySelector(`.${className}-${field}`);
    if (fieldElement && field != 'miejscowosc') {
        fieldElement.addEventListener('change', inputClicked);
    }
    if (fieldElement && field == 'miejscowosc') {

        fieldElement.addEventListener('input', inputClicked);
    }
});

const resetButton = document.querySelector(`.${resetClass}`);

if (resetButton) {
    resetButton.addEventListener('click', resetFields);
}
/*set select*/
const sortujElement = document.querySelector('.sortuj-wartosc');
const apiOfertySortujElement = document.querySelector('.api-oferty-sortuj');

if (sortujElement && apiOfertySortujElement) {

    const wybranaWartosc = sortujElement.id;

    const opcje = apiOfertySortujElement.options;
    for (let i = 0; i < opcje.length; i++) {
        if (opcje[i].value === wybranaWartosc) {

            opcje[i].selected = true;
            break;
        }
    }
}

$(document).on("click", ".change-page", function(){
    page = this.dataset.changePage;
    fetchAndInsertHTML();
  });
